import {lazy, useCallback, useContext, useMemo} from "react";
import {GlobalContext} from "@tools/globalContext";
import type {IComponentList} from "@tools/CustomInterfaces";
interface Props {
    defaultComponent?: string
}
const useLazyLoading = (props?: Props) => {
    const { hydraDirectory } = useContext(GlobalContext);
    // const result = useMemo(() => new Map(), [])

    const set = useCallback((componentList : IComponentList[]) => {
        const result = new Map();
        componentList.forEach((conf : IComponentList) => {
            const {path, name, component} = conf
            if (!result.has(name))
                result.set(name, lazy(async () => {
                    try {
                        return await import(`@root/${path}/${component || name}`)
                    }
                    catch(e){
                        console.error({name: component || name, path, error: e})
                        if (props?.defaultComponent)
                            return await import(`@root/${props?.defaultComponent}`)
                        return await import(`@root/${hydraDirectory}components/missingLazyComponent/MissingLazyComponent`)
                    }
                }))
        })

        return result
    }, [props?.defaultComponent])

    // const get = useCallback((componentName: string) => {
    //     if (result.has(componentName))
    //         return result.get(componentName)
    //     return null
    // }, [result])
    // const getAllValues = useCallback(() => {
    //     return result.values()
    // }, [result])

    return {set}
}

export default useLazyLoading;
